module.exports = __webpack_public_path__ + "img/mail.3a9a8d09.svg";